export default __webpack_public_path__ + "static/char-s-50-ja-788d8b1708b7182e4af00bd8429db3c4.webp";